<div class="flex py-3">
  <div class="flex-1">
    <h1 class="text-3xl font-semibold">Cancel Subscription</h1>
    <p class="text-lg text-gray-600">
      Cancel an active subscription for a customer. Please provide a reason for cancellation, as
      this information will help us improve our services. Once you click "Confirm Cancellation", the
      subscription will be cancelled immediately and the customer will receive a notification about
      the cancellation.
      <span class="font-bold"></span>
    </p>
  </div>
  <div class="flex">
    <button
      pButton
      class=""
      icon="pi pi-times"
      class="p-button-rounded p-button-danger mt-2 p-button-text"
      (click)="closeDialog()"
    ></button>
  </div>
</div>

<share-form
  #cancelFormRef
  [formFields]="cancelFormFields"
  [formSubmitAction]="{
    label: 'Confirm Cancellation',
    icon: 'pi pi-check',
    styleClass: 'p-button-danger',
    enabled: authz.hasPermission('subscriptions.cancel')
  }"
  (formSubmitted)="onSubmit($event)"
></share-form>
